// extracted by mini-css-extract-plugin
module.exports = {"pcWrap":"pcWrap___16uke","mobileWrap":"mobileWrap___34j57"};